import React, { useState } from 'react'
import SalesInfoHeader from '../component/SalesInfoHeader/SalesInfoHeader'
import SalesInfo from '../component/SalesInfo/SalesInfo'
import OrdersInfo from "../component/OrdersInfo/OrdersInfo"
import PaymentInfo from "../component/PaymentInfo/PaymentInfo"
import SchemeInfo from '../component/SchemeInfo/SchemeInfo'

function SalesInfoPage() {
    const [activeHeaderTab, setActiveHeaderTab] = useState(1)

    const headerData = [
        {
            id: 1,
            title: "Sales",
            icon: "/assets/images/salesInfo/sales.svg",
            width: "20px"
        },
        {
            id: 2,
            title: "orders",
            icon: "/assets/images/salesInfo/orders.svg",
            width: "20px"
        },
        {
            id: 3,
            title: "payment",
            icon: "/assets/images/salesInfo/payment.svg",
            width: "20px"
        },
        {
            id: 4,
            title: "scheme",
            icon: "/assets/images/salesInfo/sales.svg",
            width: "20px"
        }
    ]

  return (
    <div>
        <SalesInfoHeader 
        data={headerData}
        active={activeHeaderTab}
        setActive={setActiveHeaderTab}
        />

        {activeHeaderTab === 1 && <SalesInfo />}
        {activeHeaderTab === 2 && <OrdersInfo />}
        {activeHeaderTab === 3 && <PaymentInfo />}
        {activeHeaderTab === 4 && <SchemeInfo />}

    </div>
  )
}

export default SalesInfoPage